import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const USERS_ENDPOINT = `${BASE_URL}/users`;
export async function getUserData(id) {
    try {
        const response = await axios.get(`${USERS_ENDPOINT}/id/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching users data:', error);
    }
};